import { render } from "./MorphToManyField.vue?vue&type=template&id=04337d24"
import script from "./MorphToManyField.vue?vue&type=script&lang=js"
export * from "./MorphToManyField.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dennis/PhpstormProjects/lkm/doc_root/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"MorphToManyField.vue"]])

export default __exports__